module.exports = {
  footerText: 'Copyright IMPEL Technology © 2024',
}
